import { render, staticRenderFns } from "./changeStatusFrom.vue?vue&type=template&id=3dcd76dd&scoped=true&"
import script from "./changeStatusFrom.vue?vue&type=script&lang=js&"
export * from "./changeStatusFrom.vue?vue&type=script&lang=js&"
import style0 from "./changeStatusFrom.vue?vue&type=style&index=0&id=3dcd76dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcd76dd",
  null
  
)

export default component.exports